import { useAppSelector } from "@/config/store";
import { useSetPageTitle } from "@/context/PageTitleContext";
import { EdoParentState } from "@/shared/reducers/entities/edo-parent.reducer";
import { Translate } from "react-jhipster";
import { Route, Routes, useNavigate } from "react-router-dom";
import ChildDetail from "./ChildDetail/ChildDetail";

export const ParentsRoutes = () => {
  const navigate = useNavigate();
  const { children } = useAppSelector<EdoParentState>((state) => state.edoParent);
  useSetPageTitle("I miei figli", "Andamento scolastico e comunicazioni");

  const Main = () => {
    if (children.entities.length > 0) {
      navigate(`/parents/children/${children.entities[0].userId}`);
    }
    return (
      <div className="p-4 text-center">
        <p className="text-body text-[var(--color-mockup-text-mid)]">
          <Translate contentKey="userManagement.home.notFound" />
        </p>
      </div>
    );
  };

  return (
    <div className="px-4 py-6 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-5xl space-y-4">
        <Routes>
          <Route index element={<Main />} />
          <Route path="children/:id" element={<ChildDetail />} />
        </Routes>
      </div>
    </div>
  );
};

export default ParentsRoutes;
